export const COMMIT_HUMAN = "COMMIT_HUMAN";

export function commitHuman(human) {
  return {
    type: COMMIT_HUMAN,
    human,
  };
}

// UPDATE
export const UPDATE_HUMAN = "UPDATE_HUMAN";

export function updateHuman(humanId, obj) {
  return {
    type: UPDATE_HUMAN,
    humanId,
    obj,
  };
}

// REVERT
export const REVERT_HUMAN = "REVERT_HUMAN";

export function revertHuman(humanId) {
  return {
    type: REVERT_HUMAN,
    humanId,
  };
}

// DELETE
export const DELETE_HUMAN = "DELETE_HUMAN";

export function deleteHuman(id) {
  return {
    type: DELETE_HUMAN,
    id,
  };
}

// SET_HUMANS_FILTER_QUERY
export const SET_HUMANS_FILTER_QUERY = "SET_HUMANS_FILTER_QUERY";

export function setHumansFilterQuery(query) {
  return {
    type: SET_HUMANS_FILTER_QUERY,
    query,
  };
}

// SET_HUMANS_SORT_ORDER
export const SET_HUMANS_SORT_ORDER = "SET_HUMANS_SORT_ORDER";

export const HUMANS_SORT_APLHA_DOWN = "HUMANS_SORT_ORDER_APLHA_DOWN";
export const HUMANS_SORT_CREATED_AT_UP = "HUMANS_SORT_CREATED_AT_UP";

export const HUMANS_SORT_ORDERS = [
  HUMANS_SORT_APLHA_DOWN,
  HUMANS_SORT_CREATED_AT_UP,
];

export function setHumansSortOrder(order) {
  return {
    type: SET_HUMANS_SORT_ORDER,
    order,
  };
}

export const UPDATE_HUMAN_TAGS = "UPDATE_HUMAN_TAGS";

export function updateHumanTags(humanId, newName) {
  return {
    type: UPDATE_HUMAN_TAGS,
    humanId,
    newName,
  };
}
